import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { LoginService } from 'app/core/login/login.service';
import { LoginModalService } from 'app/core/login/login-modal.service';
import { StateStorageService } from 'app/core/auth/state-storage.service';

const UNAUTHORIZED = 401;

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
    constructor(
        private loginService: LoginService,
        private loginModalService: LoginModalService,
        private stateStorageService: StateStorageService,
        private router: Router
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap({
                error: (err: any) => {
                    if (err instanceof HttpErrorResponse && err.status === UNAUTHORIZED) {
                        this.onSessionExpired();
                    }
                }
            })
        );
    }

    private onSessionExpired() {
        this.loginService.logout();
        this.stateStorageService.storeUrl(this.router.url);
        this.loginModalService.open(true);
    }
}
